'use strict';

var React = require('react');

var PhoneNumber = function PhoneNumber(_ref) {
    var number = _ref.number,
        isLinked = _ref.isLinked,
        className = _ref.className;

    if (!number) return null;

    number = number.toString().replace(/[^0-9\+]+/g, '').replace(/\s+/, '');

    var formatted_number = void 0;

    if (number.length === 8) {
        formatted_number = number.replace(/([0-9]{2})([0-9]{3})([0-9]{3})/, "$1 $2 $3");
    } else if (number.length === 10) {
        formatted_number = number.replace(/([0-9]{2})([0-9]{2})([0-9]{3})([0-9]{3})/, "$2 $3 $4");
    } 
     else if (number.length === 12) {
        formatted_number = number.replace(/([0-9]{4})([0-9]{2})([0-9]{3})([0-9]{3})/, "$2 $3 $4");
    } 
    else if (number.indexOf('+') === 0) {
        formatted_number = number.replace(/([0-9]{2})([0-9]{3})([0-9]{3})([0-9]{3})/, "$1 $2 $3 $4");
    }

    if (isLinked) {
        return React.createElement(
            'a',
            { href: 'tel:' + number, className: className },
            formatted_number
        );
    } else {
        return React.createElement(
            'span',
            { className: className },
            formatted_number
        );
    }
};

PhoneNumber.defaultProps = {
    isLinked: false
};

module.exports = PhoneNumber;


// WEBPACK FOOTER //
// ./src/felles/utils/PhoneNumber.jsx